import { tokenManager } from '@/utils/security';
import { computed, type ComputedRef } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';

// 机器人是登录后功能：登录页 / 免登录路由不展示
const HIDDEN_ON_ROUTES = new Set(['Login', 'yolo-login']);

export function useChatBotVisibility(route: RouteLocationNormalizedLoaded): ComputedRef<boolean> {
  return computed(() => {
    // 必须先读 route.name，确保它始终被收集为响应式依赖。
    // 若把非响应式的 `tokenManager.getToken()` 放在 && 最前面，登录页无 token 时会短路，
    // route.name 从未被读取 → computed 无任何响应式依赖 → 缓存 false 且再也不重算，
    // 导致 SPA 登录（router.push）后机器人图标一直不出现（登录后需刷新页面才显示）。
    const name = route.name as string | null | undefined;
    if (name && HIDDEN_ON_ROUTES.has(name)) {
      return false;
    }
    return !!tokenManager.getToken();
  });
}
